var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-keyword-tags"},[_vm._m(0),_vm._v(" "),_c('ArticleKeywordTag',{attrs:{"article":_vm.article}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-keyword-tags__title-container border-softened border-bottom border-normal mt-2 pb-3 mb-1 mr-2"},[_c('h2',{staticClass:"article-keyword-tags__title-text title"},[_vm._v("Keywords")])])
}]

export { render, staticRenderFns }